import React from 'react';

import AuthorUnit from '@components/FeedItems/AuthorUnit';
import useCurrentUser from '@hooks/useCurrentUser';
import useEventTracking from '@hooks/useEventTracking';
import { ClickTarget, TrackingLocation, click } from '@tracking';

import IconClose from '../../../Images/Rebranding/IconClose';
import { userName } from '../../../User/userHelpers';

export default function CommentFormHeader({
  isEditing,
  isReplyForm,
  hideReplyForm,
  hideEditForm,
}: {
  isEditing?: boolean;
  isReplyForm?: boolean;
  hideReplyForm?: () => void;
  hideEditForm?: () => void;
}) {
  const { currentUser } = useCurrentUser();
  const { trackEvent } = useEventTracking({
    location: isReplyForm ? TrackingLocation.CommentReplySection : TrackingLocation.CommentSection,
  });

  const hideForm = () => {
    if (isReplyForm) {
      hideReplyForm();
      trackEvent(click({ clickTarget: ClickTarget.Close }));
    } else if (isEditing) {
      hideEditForm();
    }
  };

  return (
    <>
      <div className="mb-16 mt-32 flex items-center">
        <AuthorUnit
          author={{
            company: currentUser.company_name,
            isStaff: currentUser?.administrator?.is_active,
            name: userName(currentUser),
            picture: currentUser.picture_url,
            title: currentUser.title_at_company,
            username: currentUser.username,
          }}
        />
        {(isReplyForm || isEditing) && (
          <IconClose
            className="ml-auto w-28 cursor-pointer text-grayscale-charcoal"
            strokeWidth="1"
            onClick={hideForm}
          />
        )}
      </div>
    </>
  );
}
